// Applies farmCursor to a scene: the canvas cursor becomes the tool for the hovered plot.
// Uses Phaser's default cursor, so HUD buttons still show the hand while hovered and the tool
// comes back after. Preloads the icons so the first hover does not flash the arrow, and
// clears the cursor when the scene shuts down (other scenes must get the normal arrow).
import { CURSORS, cursorFor, cursorCss } from './farmCursor.mjs';

const BASE = '/assets/farm/cursors';
let preloaded = false;

function preload() {
  if (preloaded || typeof Image === 'undefined') return;
  preloaded = true;
  for (const name of Object.keys(CURSORS)) {
    for (const suffix of ['', '@2x']) { const img = new Image(); img.src = `${BASE}/cursor_${name}${suffix}.png`; }
  }
}

const supportsImageSet = (value) => {
  try { return typeof CSS !== 'undefined' && CSS.supports('cursor', value); } catch { return false; }
};

// CSS for one named tool cursor, for Phaser's per-object `cursor` (the market's crop cards).
export function toolCursor(name) {
  preload();
  const css = cursorCss(name, BASE);
  return supportsImageSet(css.imageSet) ? css.imageSet : css.plain;
}

export function attachFarmCursor(scene) {
  preload();
  let current;
  const set = (stage, tool = 'hand') => {
    const name = cursorFor(stage, tool);
    if (name === current) return;
    current = name;
    const css = cursorCss(name, BASE);
    scene.input.setDefaultCursor(supportsImageSet(css.imageSet) ? css.imageSet : css.plain);
  };
  scene.events.once('shutdown', () => { current = undefined; scene.input.setDefaultCursor(''); });
  return { set };
}
